/**
 * Get the list of assigned classes split by comma.
 * @param {Array} sections - The list of available sections.
 * @param {Array} assigned - The list of sections that have video assigned to.
 * @returns {String} - The name of assigned classes split by a comma. E.g.: Period 1, Period 2
 * */
export const getAssignedSerializedClasses = (sections = [], assigned = []) =>
  (sections || [])
    .filter((section) => (assigned || []).includes(section.classId))
    .map((section) => section.className)
    .join(', ');
